/**
 * Sanitizes URL using try/catch approach - only fixes if URL is invalid
 * @param url - The URL to sanitize
 * @returns Sanitized URL
 */
export function sanitizeUrl(url: string): string {
    if (!url || typeof url !== 'string') {
        return '/'
    }

    try {
        decodeURIComponent(url)
        return url
    } catch {
        console.warn('Invalid URL encoding detected, sanitizing:', url)

        const segments = url.split('/')

        const sanitizedSegments = segments.map((segment) => {
            try {
                decodeURIComponent(segment)
                return segment
            } catch {
                const match = segment.match(/^([A-Za-z0-9\-_]+)/)
                return match ? match[1] : ''
            }
        })

        const result = sanitizedSegments.join('/').replace(/\/+/g, '/')

        console.warn('Sanitized URL:', result)
        return result || '/'
    }
}
